<template>
  <b-container>
    <b-row class="m-0">
      <b-col md="1" />
      <b-col
        lg="10"
        class="d-flex align-items-center justify-content-center px-2 p-lg-5"
      >

        <b-col
          sm="12"
          md="12"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <validation-observer
            ref="versionForm"
            #default="{ invalid }"
          >
            <b-form @submit.prevent="submitVersion">
              <b-row>
                <!-- Version name -->
                <b-col md="6">
                  <b-form-group

                    label="Version Number"
                    label-for="Version-number"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="VersionNumber"
                      vid="Version-number"
                      rules="required"
                    >
                      <b-form-input
                        id="Version-number"
                        v-model="versionFormData.version_number"
                        name="Version-number"
                        :state="errors.length > 0 ? false : null"
                        placeholder="Version Number"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- experiment  -->
                <b-col md="6">

                  <b-form-group

                    label-for="version-experiment"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Version Experiment"
                      vid="version-experiment"
                      rules="required"
                    >
                      <b-form-group
                        label="Experiment *"
                        label-for="experiment_id"
                      >
                        <v-select
                          id="category_id"

                          v-model="versionFormData.experiment_id"
                          :options="experiments"
                          class="w-100 mb-0 custom-field"
                          :reduce="(val) => val.id"
                          placeholder="Select Category"
                          :label="$i18n.locale == 'en' ? 'name' : 'name_local'"
                        >
                          <template v-slot:option="option">{{
                            $i18n.locale == "ar" ? option.name_local : option.name
                          }}</template>
                          <template #selected-option="{ name, name_local }">
                            <div style="display: flex; align-items: baseline">
                              <strong v-if="$i18n.locale == 'ar'">{{
                                name_local
                              }}</strong>
                              <strong v-else>{{ name }}</strong>
                            </div>
                          </template>
                          <template #no-options>
                            {{ $t("noMatching") }}
                          </template>
                        </v-select>
                        <small class="text-danger float-left">{{
                          errors[0]
                        }}</small>
                      </b-form-group>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- experiment status -->
                <b-col md="6">
                  <b-form-group

                    label-for="version-status"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Version Status"
                      vid="version-status"
                      rules="required"
                    >
                      <b-form-group
                        label="Status *"
                        label-for="status\"
                      >
                        <v-select
                          id="category_id"

                          v-model="versionFormData.update_status"
                          :options="statusLookups"
                          class="w-100 mb-0 custom-field"
                          :reduce="(val) => val"
                          placeholder="Select Status"
                          :label="$i18n.locale == 'en' ? 'name' : 'name_local'"
                        >
                          <template v-slot:option="option">{{
                            $i18n.locale == "ar" ? option.name_local : option.name
                          }}</template>
                          <template #selected-option="{ name, name_local }">
                            <div style="display: flex; align-items: baseline">
                              <strong v-if="$i18n.locale == 'ar'">{{
                                name_local
                              }}</strong>
                              <strong v-else>{{ name }}</strong>
                            </div>
                          </template>
                          <template #no-options>
                            {{ $t("noMatching") }}
                          </template>
                        </v-select>
                        <small class="text-danger float-left">{{
                          errors[0]
                        }}</small>
                      </b-form-group>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- version file -->
                <b-col md="6">

                  <b-form-group

                    label="Version File"
                    label-for="version-file"
                  >
                    <ValidationProvider
                      v-slot="{ errors, validate }"
                      rules="required"
                      name="Version file"
                    >
                      <b-form-file
                        id="version-file"
                        v-model="versionFormData.file"
                        name="version-file"
                        placeholder="Upload file"
                        drop-placeholder="Drop file here..."
                        accept=".jpg,.jpeg,.png,.pdf"
                        @change="validate"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-col>

              </b-row>
              <b-row
                class="w-100 d-flex align-items-center justify-content-center p-0 py-50"
              >
                <b-button
                  type="submit"
                  variant="primary"
                  :disabled="invalid || isLoading"
                  style="
                    background-color: #727272 !important;
                    border: unset !important; width: 200px;
                  "
                >
                  <b-spinner
                    v-if="isLoading"
                    variant="primary"
                    label="Spinning"
                  />
                  <span v-else>{{ versionID ? "Update" : "Create" }}</span>
                </b-button>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <b-col md="1" />
    </b-row>
  </b-container>
</template>

<script>
import { required, image } from '@validations'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

import {
  BSpinner,
  BContainer,
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormSelect,
  BFormInput,
  BFormGroup,
  BButton,

} from 'bootstrap-vue'

export default {
  components: {
    vSelect,
    BSpinner,
    BContainer,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormFile,
    BButton,
    ValidationProvider,
    ValidationObserver,

  },

  computed: {
    ...mapGetters({
      item: 'versions/item',
      experiments: 'experiments/experimentsLookups',
      statusLookups: 'versions/statusLookups',
    }),
    versionID() {
      return this.$route.params.id ? this.$route.params.id : null
    },

  },
  data() {
    return {
      isLoading: false,
      versionFormData: {
        version_number: '',
        file: null,
        experiment_id: null,
        update_status: null,
      },

      // validation rules
      required,

    }
  },

  mounted() {
    this.init()
  },

  methods: {

    async init() {
      this.$store.dispatch('experiments/experimentLookups')

      this.$store.dispatch('versions/statusLookups')

      if (this.versionID) {
        this.$store
          .dispatch('versions/get', this.versionID)
          .then(() => {
            console.log('------------------------------>>> ', this.item)

            this.versionFormData = this.item
          })
          .catch(e => {
            this.$swal({
              icon: 'error',
              title: `<h4>Error fetching experiment details: ${e.message}</h4>`,
              showConfirmButton: true,
              confirmButtonColor: '#7367f0',
              allowOutsideClick: true,
            })
          })
      }
    },
    submitVersion() {
      const formData = new FormData()

      formData.append('version_number', this.versionFormData.version_number)
      formData.append('file', this.versionFormData.file)
      formData.append('experiment_id', this.versionFormData.experiment_id)
      formData.append('update_status', this.versionFormData.update_status)

      this.$refs.versionForm.validate().then(success => {
        if (success) {
          this.isLoading = true

          if (this.versionID) {
            formData.append('id', this.versionID)

            this.$store
              .dispatch('versions/update', {
                query: formData,
                id: this.versionID,
              })
              .then(response => {
                this.$swal({
                  icon: 'success',
                  title: '<h4>Version updated successfully! </h4>',
                  showConfirmButton: true,
                  confirmButtonColor: '#7367f0',
                  allowOutsideClick: true,
                })

                this.isLoading = false
              })
              .catch(error => {
                this.isLoading = false

                if (error.response) {
                  this.$swal({
                    icon: 'error',
                    title: `<h4>${error.response.data.error}</h4> `,
                    showConfirmButton: true,
                    confirmButtonColor: '#7367f0',
                    allowOutsideClick: true,
                  })
                }
              })
          } else {
            console.log('CREATING experiment with formData:', formData)
            this.$store
              .dispatch('versions/put', formData)
              .then(response => {
                this.$swal({
                  icon: 'success',
                  title: '<h4>Version created successfully! </h4>',
                  showConfirmButton: true,
                  confirmButtonColor: '#7367f0',
                  allowOutsideClick: true,
                })

                this.$router.push({
                  name: 'versions',
                })
                // this.$router.push({
                //   name: "experiment_details",
                //   params: { id: response.data.id },
                // });
                this.isLoading = false
              })
              .catch(error => {
                this.isLoading = false

                if (error.response) {
                  this.$swal({
                    icon: 'error',
                    title: `<h4>${error.response.data.error}</h4> `,
                    showConfirmButton: true,
                    confirmButtonColor: '#7367f0',
                    allowOutsideClick: true,
                  })
                }
              })
          }
        } else {
          console.log('Validation failed')

          this.$swal({
            icon: 'error',
            title: `<h4>Validation Error: ${error.response.data.message}</h4>`,
            showConfirmButton: true,
            confirmButtonColor: '#7367f0',
            allowOutsideClick: true,
          })
        }
      })
    },
  },
}
</script>
